import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import Button from '../../components/atoms/Button.mjs';
import { usePresentation, getButtonId } from '../../components/PresentationConfig.mjs';
import { useStytch } from '../GlobalContextProvider.mjs';
import { OAuthProviders } from '../../../../../core/src/public/ui.mjs';

const providerInfo = {
    [OAuthProviders.Google]: {
        messageDescriptor: {
            id: "oauth.continueWithGoogle"
        }
    },
    [OAuthProviders.Microsoft]: {
        messageDescriptor: {
            id: "oauth.continueWithMicrosoft"
        }
    },
    [OAuthProviders.Apple]: {
        messageDescriptor: {
            id: "oauth.continueWithApple"
        }
    },
    [OAuthProviders.Github]: {
        messageDescriptor: {
            id: "oauth.continueWithGitHub"
        }
    },
    [OAuthProviders.GitLab]: {
        messageDescriptor: {
            id: "oauth.continueWithGitLab"
        }
    },
    [OAuthProviders.Facebook]: {
        messageDescriptor: {
            id: "oauth.continueWithFacebook"
        }
    },
    [OAuthProviders.Discord]: {
        messageDescriptor: {
            id: "oauth.continueWithDiscord"
        }
    },
    [OAuthProviders.Salesforce]: {
        messageDescriptor: {
            id: "oauth.continueWithSalesforce"
        }
    },
    [OAuthProviders.Slack]: {
        messageDescriptor: {
            id: "oauth.continueWithSlack"
        }
    },
    [OAuthProviders.Amazon]: {
        messageDescriptor: {
            id: "oauth.continueWithAmazon"
        }
    },
    [OAuthProviders.Bitbucket]: {
        messageDescriptor: {
            id: "oauth.continueWithBitbucket"
        }
    },
    [OAuthProviders.LinkedIn]: {
        messageDescriptor: {
            id: "oauth.continueWithLinkedIn"
        }
    },
    [OAuthProviders.Coinbase]: {
        messageDescriptor: {
            id: "oauth.continueWithCoinbase"
        }
    },
    [OAuthProviders.Twitch]: {
        messageDescriptor: {
            id: "oauth.continueWithTwitch"
        }
    },
    [OAuthProviders.Twitter]: {
        messageDescriptor: {
            id: "oauth.continueWithX"
        }
    },
    [OAuthProviders.TikTok]: {
        messageDescriptor: {
            id: "oauth.continueWithTikTok"
        }
    },
    [OAuthProviders.Snapchat]: {
        messageDescriptor: {
            id: "oauth.continueWithSnapchat"
        }
    },
    [OAuthProviders.Figma]: {
        messageDescriptor: {
            id: "oauth.continueWithFigma"
        }
    },
    [OAuthProviders.Yahoo]: {
        messageDescriptor: {
            id: "oauth.continueWithYahoo"
        }
    }
};
const OAuthButton = ({ providerType, loginRedirectUrl, signupRedirectUrl, customScopes, providerParams, onSuccess })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const stytchClient = useStytch();
    const presentation = usePresentation();
    const iconRegistry = presentation.iconRegistry;
    const id = getButtonId(`oauth-${providerType}`, presentation.options);
    const provider = providerInfo[providerType];
    let label = providerType;
    let icon = null;
    if (provider) {
        const { messageDescriptor } = provider;
        const iconName = providerType === 'twitter' ? 'xTwitter' : providerType;
        const Icon = iconRegistry[iconName];
        label = $__i18n._(messageDescriptor);
        icon = /*#__PURE__*/ React__default.createElement(Icon, null);
    }
    const onButtonClick = async ()=>{
        await stytchClient.oauth[providerType].start({
            login_redirect_url: loginRedirectUrl,
            signup_redirect_url: signupRedirectUrl,
            custom_scopes: customScopes,
            provider_params: providerParams
        });
        onSuccess?.();
    };
    return /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onButtonClick,
        variant: "outline",
        icon: icon,
        id: id
    }, label);
};

export { OAuthButton };
//# sourceMappingURL=OAuthButton.mjs.map
